<template>
  <el-dialog
    :title="$t('audit.auditInfo')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="auditInfo" label-width="120px">
      <el-form-item :label="$t('audit.auditStatus')" prop="state" :rules="[{ required: true, message: $t('audit.selectAuditStatus'), trigger: 'change' }]">
        <el-select
          v-model="auditInfo.state"
          :placeholder="$t('audit.selectAuditStatus')"
          style="width:100%"
          @change="handleStateChange"
        >
          <el-option
            :label="$t('audit.agree')"
            value="1100"
          />
          <el-option
            :label="$t('audit.reject')"
            value="1200"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('audit.reason')" prop="remark" :rules="[{ required: true, message: $t('audit.inputReason'), trigger: 'blur' }]">
        <el-input
          v-model="auditInfo.remark"
          type="textarea"
          :placeholder="$t('audit.inputReason')"
          :rows="4"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">{{ $t('common.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditInoutOrder } from '@/api/goods/inoutOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'UpShopHouseAudit',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      orderData: null,
      auditInfo: {
        state: '',
        remark: ''
      }
    }
  },
  methods: {
    open(order) {
      this.orderData = order
      this.resetForm()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.auditInfo = {
        state: '',
        remark: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleStateChange(val) {
      if (val === '1100') {
        this.auditInfo.remark = this.$t('audit.agree')
      } else {
        this.auditInfo.remark = ''
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        if (!this.orderData) {
          this.$message.error('订单数据不存在')
          return
        }

        this.loading = true
        
        // 构造审核数据
        const auditData = {
          ...this.orderData,
          state: this.auditInfo.state,
          stateRemark: this.auditInfo.remark,
          shopId: getShopId()
        }

        await auditInoutOrder(auditData)
        
        this.$message.success(this.$t('common.auditSuccess'))
        this.handleClose()
        this.$emit('refresh')
      } catch (error) {
        if (error.message) {
          this.$message.error(error.message)
        } else {
          console.error('审核失败:', error)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
